import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";

export const getRetailer = (): IRetailer | undefined => {
  return getGlobalProperty("retailer");
};

export const isRetailer = (): boolean => getRetailer() !== undefined;

export const getRetailerToken = () => getRetailer()?.token;

export const getRetailerEmail = () => getRetailer()?.email_address;

export const getRetailerBusinessName = () => getRetailer()?.name;

export const getRetailerCountry = () =>
  getRetailer()?.country ?? getRetailerDefaultShippingAddress()?.country;

export const getRetailerTaxableCountry = () =>
  getRetailerDefaultShippingAddress()?.country ?? getRetailerCountry();

export const getRetailerActiveMemberships = () => {
  const memberships = getRetailer()?.memberships;

  return memberships?.find((membership) => membership.active);
};

const getRetailerDefaultShippingAddress = () =>
  getRetailer()?.default_shipping_address;
